import React from 'react';

const NotFound = () => {

    return (
        <div className='container py-[100px]'>
            <h5 className='text-[65px] text-center font-semibold'>404 Error Page Not Found</h5>
            <a href='/' className='w-[200px] text-[18px] font-bold bg-[#F2F0F0] h-[52px] items-center transform transition-all duration-300 hover:scale-105 text-center rounded-[30px] cursor-pointer flex justify-center mb-0 mt-[40px] mx-auto'
            >
                Home Page
            </a>
        </div>
    );
};

export default NotFound;
